document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.wc-ai-penalty').forEach(function (game) {
    const userScoreEl = game.querySelector('[data-user-score]');
    const aiScoreEl = game.querySelector('[data-ai-score]');
    const keeper = game.querySelector('[data-keeper]');
    const ball = game.querySelector('[data-ball]');
    const message = game.querySelector('[data-message]');
    const gameArea = game.querySelector('.wc-ai-penalty__game');
    const restart = game.querySelector('[data-restart]');
    const winBox = game.querySelector('[data-win-box]');
    const loseBox = game.querySelector('[data-lose-box]');
    const closeLose = game.querySelector('[data-close-lose]');
    const copyBtn = game.querySelector('[data-copy-code]');
    const tutorial = game.querySelector('[data-tutorial]');
    const promoCode = game.querySelector('[data-promo-code]')?.textContent || '';

    if (!gameArea || !ball || !keeper) return;

    let userScore = 0;
    let aiScore = 0;
    let round = 1;
    let maxRounds = 5;
    let userShots = [];
    let locked = false;
    let startX = 0;
    let startY = 0;
    let dragging = false;

    const directions = ['left', 'center', 'right'];

    const targets = {
      left: { x: '39%', y: '190px' },
      center: { x: '50%', y: '198px' },
      right: { x: '61%', y: '190px' }
    };

    function updateScore() {
      userScoreEl.textContent = userScore;
      aiScoreEl.textContent = aiScore;
    }

    function resetVisuals() {
      ball.className = 'wc-ai-penalty__ball';
      ball.style.left = '';
      ball.style.bottom = '';
      ball.style.transform = '';
      ball.style.removeProperty('--target-x');
      ball.style.removeProperty('--target-y');

      keeper.className = 'wc-ai-penalty__keeper dive-center';
      if (keeper.dataset.center) keeper.src = keeper.dataset.center;
    }

    function setKeeper(direction) {
      keeper.className = 'wc-ai-penalty__keeper dive-' + direction;

      if (direction === 'left' && keeper.dataset.left) keeper.src = keeper.dataset.left;
      if (direction === 'right' && keeper.dataset.right) keeper.src = keeper.dataset.right;
      if (direction === 'center' && keeper.dataset.center) keeper.src = keeper.dataset.center;
    }

    function shootBall(direction) {
      ball.style.setProperty('--target-x', targets[direction].x);
      ball.style.setProperty('--target-y', targets[direction].y);
      ball.className = 'wc-ai-penalty__ball shooting';
    }

    function getSwipeDirection(endX, endY) {
      const diffX = endX - startX;
      const diffY = endY - startY;

      if (Math.abs(diffX) < 24 && Math.abs(diffY) < 24) return null;

      if (diffX < -35) return 'left';
      if (diffX > 35) return 'right';

      return 'center';
    }

    function hardAiPrediction(userShot) {
      userShots.push(userShot);

      const lastThree = userShots.slice(-3);
      const repeated = lastThree.find(function (shot) {
        return lastThree.filter(function (item) {
          return item === shot;
        }).length >= 2;
      });

      const chance = Math.random();

      if (chance < 0.58) return userShot;
      if (repeated && chance < 0.82) return repeated;

      return directions[Math.floor(Math.random() * directions.length)];
    }

    function playerShoot(direction) {
      if (locked) return;

      locked = true;
      if (tutorial) tutorial.classList.add('hide');

      const aiDive = hardAiPrediction(direction);

      message.textContent = 'AI keeper is reading your shot...';

      setTimeout(function () {
        shootBall(direction);
        setKeeper(aiDive);

        setTimeout(function () {
          if (direction === aiDive) {
            message.textContent = 'SAVED! AI predicted your shot.';
          } else {
            userScore++;
            message.textContent = 'GOAL! Beautiful finish.';
          }

          updateScore();
          setTimeout(aiAutoTurn, 1050);
        }, 850);
      }, 220);
    }

    function aiAutoTurn() {
      resetVisuals();

      message.textContent = 'AI is taking its penalty...';

      const aiShot = directions[Math.floor(Math.random() * directions.length)];
      const autoKeeperDive = directions[Math.floor(Math.random() * directions.length)];

      setTimeout(function () {
        shootBall(aiShot);
        setKeeper(autoKeeperDive);

        setTimeout(function () {
          if (aiShot === autoKeeperDive) {
            message.textContent = 'YOUR KEEPER SAVED IT!';
          } else {
            aiScore++;
            message.textContent = 'AI SCORES!';
          }

          updateScore();
          round++;

          setTimeout(checkGame, 1050);
        }, 850);
      }, 650);
    }

    function showLosePopup() {
      if (loseBox) loseBox.classList.add('active');
    }

    function checkGame() {
      resetVisuals();

      if (round > maxRounds) {
        if (userScore > aiScore) {
          locked = true;
          message.textContent = 'You won the penalty shootout!';
          winBox.classList.add('active');
          return;
        }

        if (aiScore > userScore) {
          locked = true;
          message.textContent = 'AI wins. Try again!';
          showLosePopup();
          return;
        }

        maxRounds++;
        message.textContent = 'Sudden death!';
      }

      locked = false;
      message.textContent = 'Round ' + round + '. Swipe left, center, or right.';
    }

    function resetGame() {
      userScore = 0;
      aiScore = 0;
      round = 1;
      maxRounds = 5;
      userShots = [];
      locked = false;
      dragging = false;

      if (loseBox) loseBox.classList.remove('active');
      if (winBox) winBox.classList.remove('active');
      if (tutorial) tutorial.classList.remove('hide');

      updateScore();
      resetVisuals();

      message.textContent = 'Round 1. Swipe left, center, or right.';
    }

    gameArea.addEventListener('pointerdown', function (event) {
      if (locked) return;

      dragging = true;
      startX = event.clientX;
      startY = event.clientY;

      ball.classList.add('dragging');

      if (gameArea.setPointerCapture) {
        gameArea.setPointerCapture(event.pointerId);
      }
    });

    gameArea.addEventListener('pointermove', function (event) {
      if (!dragging || locked) return;

      const diffX = event.clientX - startX;
      const diffY = event.clientY - startY;

      const limitedX = Math.max(-70, Math.min(70, diffX * 0.24));
      const limitedY = Math.max(-36, Math.min(20, diffY * 0.12));

      ball.style.transform = `translate(calc(-50% + ${limitedX}px), ${limitedY}px)`;
    });

    gameArea.addEventListener('pointerup', function (event) {
      if (!dragging || locked) return;

      dragging = false;
      ball.classList.remove('dragging');

      const direction = getSwipeDirection(event.clientX, event.clientY);

      if (!direction) {
        resetVisuals();
        message.textContent = 'Swipe stronger: left, center, or right.';
        return;
      }

      playerShoot(direction);
    });

    gameArea.addEventListener('pointercancel', function () {
      dragging = false;
      resetVisuals();
    });

    restart.addEventListener('click', resetGame);

    if (closeLose) {
      closeLose.addEventListener('click', resetGame);
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(promoCode);
        copyBtn.textContent = 'Copied!';
      });
    }

    updateScore();
    resetVisuals();
    message.textContent = 'Round 1. Swipe left, center, or right.';
  });
});